/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Shared by the Angular route host and list pages that add expandable children.
 */
import {DestroyRef} from '@angular/core';
import * as _ from 'lodash';
import {OBJECT_TYPE} from '../constants/object-type';
import {SignalResourceListBindingService} from './signal-resource-list-binding.service';

export function columnFinder(ctrl: any, columnField: string, param: string): boolean {
  const columnArray = _.get(ctrl, [columnField], []);
  return _.isArray(columnArray) ? !!_.find(columnArray, (item: any) => {
    return item === param || _.get(item, ['param']) === param || _.get(item, ['label']) === param;
  }) : false;
}

export function getListChildren(
  ctrl: any,
  listBinding: SignalResourceListBindingService,
  objectType: any,
  ChildResourceFactory: any,
  destroyRef: DestroyRef
): void {
  const ctrlChildren: any = {};
  ctrl.getChildren = function(item: any) {
    item.showChildren = !item.showChildren;
    if (!ctrlChildren[item.id]) {
      const theConfig: any = {moreParams: {}};
      theConfig.moreParams[objectType.apiParam] = item.id;
      theConfig.childCall = true;
      if (objectType.childType) {
        theConfig.baseTable = OBJECT_TYPE[objectType.childType].apiParam;
      }
      ctrlChildren[item.id] = listBinding.create(
        ChildResourceFactory,
        'full' + _.get(OBJECT_TYPE[objectType.childType], 'type') + 'List',
        destroyRef,
        theConfig,
        {readOnly: ctrl.readOnly}
      );
    }
  };
  ctrl.children = ctrlChildren;
}
